import { render, staticRenderFns } from "./ClientWorkItem.vue?vue&type=template&id=25414261&"
import script from "./ClientWorkItem.vue?vue&type=script&lang=js&"
export * from "./ClientWorkItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientWorkItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientWorkItem.vue"
export default component.exports